<form [formGroup]="configurationFormAcodis">
  <div class="form-row row">
    <div class="form-group col-xl-4 col-lg-6">
      <label class="control-label required">{{'i18n.domain.import-configuration.edit.file.acodis.acodis-workflow' | translate}}</label>
      <ejs-dropdownlist #acodisWorkflowId formControlName="acodisWorkflowId" [showClearButton]="false"
        [dataSource]="acodisWorkflows" [fields]="fields">
      </ejs-dropdownlist>
      <app-error-messages [control]="configurationFormAcodis.controls.acodisWorkflowId"></app-error-messages>
    </div>
    <div class="form-group col-xl-4 col-lg-6">
      <label class="control-label required">{{'i18n.domain.import-configuration.edit.file.acodis.acodis-category' | translate}}</label>
      <ejs-dropdownlist #acodisCategoryId formControlName="category" [showClearButton]="false"
        [dataSource]="acodisCategories" [fields]="fields">
      </ejs-dropdownlist>
      <app-error-messages [control]="configurationFormAcodis.controls.category"></app-error-messages>
    </div>
  </div>
  @if (acodisCategoriesErrorMsg) {
    <div class="form-row row">
      <div class="form-group col-12">
        <span class="text-danger">{{'i18n.domain.import-configuration.edit.file.acodis.cannot-get-categories' | translate}}</span><br>
        <span class="text-danger">{{'i18n.domain.import-configuration.edit.file.acodis.error-details' | translate}}{{acodisCategoriesErrorMsg}}</span>
      </div>
    </div>
  }
</form>
